//import Validation from "react-validation";
import validator from "validator";
/*
Object.assign(Validation.rules, {
  required: {
    rule: (value) => {
      return value.toString().trim();
    },
    hint: (value) => {
      return <span className="form-error is-visible">Obvezen podatek</span>;
    },
  },
  email: {
    rule: (value) => {
      return validator.isEmail(value);
    },
    hint: (value) => {
      return (
        <span className="form-error is-visible">
          {value} ni veljaven e-poštni naslov
        </span>
      );
    },
  },
});*/

export function validate(rule, value) {
  switch (rule) {
    case "required":
      return value.toString().trim();
    case "email":
      return validator.isEmail(value);
    case "url":
      return validator.isURL(value);
  }
}
